export default __webpack_public_path__ + "ea3d2e01a5b3750f04384db4fe37a91d.svg";